<template>
  <div>
    <div v-if="$store.state.shop.info.id">
      <div v-if="type == 'query'">
        客服人员：
        <el-button type="primary" @click="handleClick">设置店铺客服</el-button>

        <el-table ref="queryTable" :data="list" stripe style="width: 100%">
          <el-table-column width="100" label="头像">
            <template slot-scope="scope">
              <el-image
                v-if="scope.row.avatar"
                fit="cover"
                :src="scope.row.avatar | fixImgUrl"
              ></el-image>
              <img v-else src="@/assets/preload-head-online.jpg" style="width:50px;height:50px;" />
            </template>
          </el-table-column>
          <el-table-column prop="name" label="姓名"></el-table-column>
          <el-table-column prop="nickname" label="昵称"></el-table-column>
          <el-table-column prop="mobile" label="手机号"></el-table-column>
          <el-table-column prop="imStatus" label="在线状态">
            <template slot-scope="scope">{{
              scope.row.imStatus === 1 ? '在线' : '不在线'
            }}</template>
          </el-table-column>
        </el-table>
      </div>
      <div v-else-if="type == 'edit'">
        <div>
          添加客服人员：
          <el-input
            style="width:200px"
            v-model.trim="userPhone"
            placeholder="请输入添加客服手机号"
            clearable
            :maxlength="11"
          ></el-input>
          <el-button style="margin-left:20px" type="primary" @click="queryUserInfo"
            >添加客服</el-button
          >
        </div>
        <div style="margin-top: 30px;">当前客服人员：</div>
        <el-table ref="editTable" :data="tableList" stripe style="width: 100%">
          <el-table-column label="序号" width="100">
            <template slot-scope="scope">{{ scope.$index + 1 }}</template>
          </el-table-column>
          <el-table-column prop="name" label="姓名" width="180"></el-table-column>
          <el-table-column prop="nickname" label="昵称" width="180"></el-table-column>
          <el-table-column prop="mobile" label="手机号"></el-table-column>

          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button
                @click.native.prevent="deleteRow(scope.$index, tableList)"
                type="text"
                size="small"
                >移除</el-button
              >
              <el-button
                v-if="scope.$index !== 0"
                @click="upOrder(scope.$index)"
                type="text"
                size="small"
                >上移</el-button
              >
              <el-button
                v-if="scope.$index !== tableList.length - 1"
                @click="downOrder(scope.$index)"
                type="text"
                size="small"
                >下移</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <div style="margin-top:20px;text-align:center">
          <el-button @click="type = 'query'">取消</el-button>
          <el-button type="primary" @click="sure">确认</el-button>
        </div>
      </div>
    </div>
    <div class="empty" v-if="!$store.state.shop.info.id">
      <img src="@/assets/shop-server-empty.png" />
      <div class="tips">你还未设置店铺信息哦，设置后才可以设置客服~</div>
      <el-button type="primary" @click="$router.push('/shop/info')">立即设置店铺信息</el-button>
    </div>
  </div>
</template>

<script>
import { FILE_ROOT } from '@/common/constants/index'
import { validateMobile } from '@/common/utils/validate'
export default {
  data() {
    return {
      type: 'query' /** 页面状态 query查询 edit编辑 */,
      list: [],
      tableList: [],
      userPhone: ''
    }
  },
  created() {
    this.getList()
  },
  filters: {
    fixImgUrl(fk) {
      return FILE_ROOT + fk + '?x-oss-process=image/resize,m_lfit,h_50,w_50'
    }
  },
  methods: {
    /** 获取当前店铺客服信息 */
    async getList() {
      try {
        const result = await this.$get('shop.adminCurrentShopCustomerService')
        if (result.success) {
          this.list = result.data[0].customerServices
          // const {success,data} = await this.$post('user.getBatchUserStatus', { userBatchQuery: {userIds:csList.map(item => item.userId)} })
          // if(success){
          //   const statList = data[0].value
          //   let newlist = []
          //   for(let cs of csList) {
          //     const temp = statList.filter(i => i.userId === cs.userId)[0];
          //     newlist.push({...cs, onlineStatus:temp.status});
          //   }
          //   this.list = newlist
          // }
        }
      } catch (err) {
        console.log(err)
      }
    },
    handleClick() {
      this.userPhone = ''
      this.tableList = Object.assign(this.tableList, this.list)
      this.type = 'edit'
    },
    /** 查询客服的名字 */
    async queryUserInfo() {
      if (!validateMobile(this.userPhone)) {
        this.$message.error('请填写正确的手机号码！')
        return
      }
      try {
        const result = await this.$post('user.getUserInfoByMobileNo', {
          mobileNo: this.userPhone
        })

        let hadsetting = false
        if (result.success) {
          const tempUserId = result.data[0].id
          this.tableList.forEach(item => {
            if (item.userId == tempUserId || item.id == tempUserId) {
              hadsetting = true
            }
          })
          if (hadsetting) {
            this.$message.warning('此客服人员已添加！')
            return
          } else {
            this.tableList = [
              ...this.tableList,
              Object.assign({ mobile: this.userPhone }, result.data[0])
            ]
          }
        }
      } catch (err) {
        console.log(err)
      }
    },
    deleteRow(index, rows) {
      rows.splice(index, 1)
    },
    upOrder(index) {
      this.tableList.splice(index - 1, 0, this.tableList[index])
      this.tableList.splice(index + 1, 1)
    },
    downOrder(index) {
      this.tableList.splice(index + 2, 0, this.tableList[index])
      this.tableList.splice(index, 1)
    },
    async sure() {
      let memberAddInfos = []
      this.tableList.forEach((item, index) => {
        memberAddInfos.push({
          userId: item.userId ? item.userId : item.id,
          type: 'CUSTOMER_SERVICE',
          showSort: index + 1
        })
      })

      try {
        const result = await this.$post('shop.adminEditShopCustomerService', {
          request: { memberAddInfos }
        })
        if (result.success && result.data[0].value) {
          this.$message.success('设置成功')
          this.type = 'query'
          this.getList()
        } else {
          this.$message.error('设置失败')
        }
      } catch (err) {
        console.log(err)
      }
    }
  }
}
</script>
<style lang="less" scoped>
.list {
  display: flex;
  flex-wrap: wrap;
  .list-wrap {
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    border-radius: 10px;
    border: 1px solid #e6ebf5;
    background-color: #ffffff;
    overflow: hidden;
    color: #303133;
    transition: 0.3s;
    width: 350px;
    margin: 15px 15px;
    padding: 20px;
    display: flex;
    .wrap-left {
      img {
        width: 50px;
        height: 50px;
        border-radius: 50%;
      }
    }
    .wrap-main {
      padding: 0 20px;
      flex: 1;
    }
  }
}
.empty {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;

  img {
    width: 150px;
    height: 150px;
  }

  .tips {
    text-align: center;
    margin: 20px auto;
    color: #999;
  }
}
</style>
